import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getPageBrowserTabTitleWithEntityName,
  usePageBrowserTabTitle,
} from '../../../hooks'
import { Divider } from '../../Divider'

import { EmailProfileRawMessage } from './EmailProfileRawMessage'
import { Header } from './Header'
import { Subject } from './Subject'

import * as styles from './EmailProfileRaw.module.css'

function EmailProfileRaw({ messages, requestNumber, subject }) {
  const { t } = useTranslation()

  usePageBrowserTabTitle({
    pageTitle: getPageBrowserTabTitleWithEntityName({
      name: subject,
      title: t('BrowserTab.EmailProfileRawTabTitleKey'),
    }),
  })

  return (
    <div className={styles.EmailProfileRaw}>
      <Header />
      <Divider className={styles.divider} />
      <Subject
        messages={messages}
        requestNumber={requestNumber}
        subject={subject}
      />

      {messages.length > 0
        ? messages.map((item, index) => (
            <Fragment key={index}>
              <Divider className={styles.divider} />
              <EmailProfileRawMessage {...item} />
            </Fragment>
          ))
        : null}
    </div>
  )
}

export default EmailProfileRaw
